export const alternatingConcat = (arr1, arr2) => {
  const length = Math.min(arr1.length, arr2.length);
  return [].concat(
    ...Array.from({ length }, (_, i) => [arr1[i], arr2[i]]),
    arr1.slice(length),
    arr2.slice(length),
  );
};
